<template>
  <div class="service-unavailable">
    <div class="wrapper">
      <Navigation />
      <div class="service-unavailable__body">
        <div class="service-unavailable__main">
          <img class="service-unavailable__image" src="../../assets/images/not-found/shark-not-found.svg" alt="maintenance" />
          <div class="service-unavailable__info">
            <div class="service-unavailable__title">{{ $t('serviceUnavailable.title') }}</div>
            <p class="service-unavailable__description">{{ $t('serviceUnavailable.description') }}</p>
            <Button left-icon="/logPass/arrow-back.svg" class="service-unavailable__button" size="md" @click="reloadPage">
              {{ $t('serviceUnavailable.button') }}
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './serviceUnavailable.scss'

import Navigation from '@/components/Navigation/Navigation.vue'
import Button from '@/components/Base/Button/Button.vue'

export default {
  name: 'ServiceUnavailable',
  components: { Button, Navigation },
  methods: {
    // Экран показывается двумя способами: поверх текущей страницы по флагу в
    // store (обычный случай) и роутером при прямом заходе на /503. В первом
    // случае адрес — это страница, с которой человек пришёл, и перезагрузка
    // возвращает его туда же: раньше кнопка всегда выкидывала на главную, а
    // сохранённый маршрут писали в sessionStorage и нигде не читали. Во втором
    // случае возвращаться некуда, ведём на главную (RBXGD-1119).
    reloadPage() {
      if (this.$route.path === '/503') {
        window.location.href = '/'

        return
      }

      window.location.reload()
    }
  }
}
</script>
